import { call, put } from "redux-saga/effects";
import { requestStoreData } from "../requests/userFilterStore";
import {
  setStoreData,
  setStoreDataLoading,
  setStoreDataError
} from "../../entities/userFIlterStore";

export function* handleFetchData(action) {
  try {
    yield put(setStoreDataLoading());

    const selectedMake = action.payload;
    const { generations, enginesByGeneration, generationToModel } = yield call(
      requestStoreData,
      selectedMake
    );

    yield put(setStoreData({ generations, enginesByGeneration, generationToModel }));
  } catch (error) {
    yield put(setStoreDataError(error.message));
  }
}
